import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=1adc3eb5&scoped=true&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=js&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&id=1adc3eb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc3eb5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
